export function debounce<F extends (...args: any[]) => void>(fn: F, timeMs: number): F {
  let timeoutId: any = null;

  return ((...args: any[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      fn(...args);
    }, timeMs);
  }) as F;
}
